import { ActionTypes } from '../actions/types';

const initialState = {
  adressenliste: [],
  reloadToggle: false, // Wert ist egal, hauptsache, er �ndert sich, damit useEffect getriggert wird
  totalSearchResults: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_ADRESSEN: {
      return {
        ...state,
        adressenliste: payload,
      };
    }
    case ActionTypes.RELOAD_ADRESSMANAGEMENT: {
      return {
        ...state,
        reloadToggle: !state.reloadToggle,
      };
    }
    case ActionTypes.SET_TOTALSEARCHRESULTS: {
      return {
        ...state,
        totalSearchResults: payload,
      };
    }
    default:
      return state;
  }
  return state;
}
